import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const HeaderHeartActiveIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M19.23 1.56001C16.74 0.74001 13.88 1.59001 12 3.62001C10.11 1.58001 7.25998 0.74001 4.76998 1.56001C2.04998 2.44001 0.23998 4.97001 0.24998 7.84001C0.27998 14.71 6.41998 20.13 11.67 22.68C11.88 22.78 12.12 22.78 12.33 22.68C17.58 20.13 23.72 14.72 23.75 7.84001C23.76 4.97001 21.95 2.45001 19.23 1.56001Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

HeaderHeartActiveIcon.displayName = 'HeaderHeartActiveIcon';
